import loadExternalStylesheet from "../../utils/loadExternalStylesheet";
import loadExternalScript from "../../utils/loadExternalScript";

export default function loadTheoPlayerScript(node) {
    const libraryLocation = window.REBELMOUSE_BOOTSTRAP_DATA.engine.theoPlayerLibraryLocation;
    const existingScript = document.querySelector(
        `script[src="${libraryLocation}THEOplayer.js"`
    );
    if (!existingScript) {
        let _this = this;
        this.isResolved = false;
        this.promise = new Promise((resolve) => {
            window.addEventListener('theoplayerready', (function() {
                _this.isResolved = true;
                resolve();
            }));
            loadExternalStylesheet(`${libraryLocation}ui.css`, () => {});
            loadExternalScript(`${libraryLocation}THEOplayer.js`, () => {});
        });
    }
    
    if (!this.isResolved) {
        this.promise.then(() => initializeTheoPlayer(node, libraryLocation));
    } else {
        initializeTheoPlayer(node, libraryLocation)
    }
}

function initializeTheoPlayer(node, libraryLocation) {
    if (node.player !== undefined) {
        return;
    }
    node.classList.add("video-js", "theoplayer-skin", "vjs-fluid", "vjs-16-9");
    var player = window.THEOplayer.Player(node, {libraryLocation: libraryLocation});
    var preplayParameters = {};
    player.source = {
        sources: [{
            id: [ node.dataset.videoId], integration: "verizon-media", preplayParameters: preplayParameters,
        }]
    };
    player.autoplay = true;
    player.preload = "auto";
}
